/* Neu Appliance Outlet — Connections & Services auto-add · Layer 1 (PDP).
   Task 86e22uqy8. Custom replacement for the EasyGift app (which can no longer
   auto-add full-price items).

   How it works: the PDP renders (a) the connection map — every install
   connector/service product + the appliance tags that require it, sourced from
   the shop metafield custom.install_connections (see snippet neu-connections-data)
   — and (b) THIS product's tags. This script matches the two, then intercepts the
   storefront's /cart/add call (both the Horizon "Add to Cart" form AND the custom
   "Buy It Now" button use fetch) and injects the required connectors into the cart
   BEFORE the original add resolves. That guarantees the connectors are present when
   Horizon re-renders the cart drawer, and when Buy-It-Now redirects to /checkout.
   A small on-brand toast confirms what was added.

   Layer 2 (the "Installation Requirement" subtitle + the removal-guard popup) lives
   in cart-products.liquid + neu-cart-skin.liquid and is unaffected by this file. */
(function () {
  'use strict';

  var mapEl = document.getElementById('neu-conn-map');
  var tagsEl = document.getElementById('neu-pdp-tags');
  if (!mapEl) return;

  var MAP = [];
  var TAGS = [];
  try { MAP = JSON.parse(mapEl.textContent || '[]') || []; } catch (e) { MAP = []; }
  try { TAGS = JSON.parse((tagsEl && tagsEl.textContent) || '[]') || []; } catch (e) { TAGS = []; }
  if (!MAP.length || !TAGS.length) return; // no data, or this product carries no tags

  // Which tags does the current appliance have? (case-insensitive)
  var tagSet = {};
  TAGS.forEach(function (t) { if (t != null) tagSet[String(t).trim().toLowerCase()] = true; });

  // Match the map: an entry applies if ANY of its qualifying tags is on the product.
  // The ventless-dryer exclusion is handled by the tag data itself (the vent tube is
  // keyed to Venting_*_Vented tags only), so no AND-NOT logic is needed here.
  var seen = {};
  var NEEDED = [];
  MAP.forEach(function (e) {
    if (!e || !e.id) return;
    var qualifies = (e.tags || []).some(function (t) { return tagSet[String(t).trim().toLowerCase()]; });
    if (qualifies && !seen[e.id]) { seen[e.id] = true; NEEDED.push(e); }
  });
  if (!NEEDED.length && !document.getElementById('neu-warranty')) return; // no connectors AND no warranty widget — stay inert

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;
  var busy = false;

  function isAddUrl(u) { return /\/cart\/add(\.js)?($|\?)/.test(String(u || '')); }

  // Add every still-missing companion in ONE /cart/add.js request: required connectors (auto) plus the
  // Neu Shield plan the shopper chose on the PDP (window.__neuWarranty). Deduped against the current cart.
  function addConnectors() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = {};
        (cart.items || []).forEach(function (i) { have[i.variant_id] = true; });
        var items = [], added = [];
        NEEDED.filter(function (e) { return !have[e.id]; }).forEach(function (e) {
          items.push({ id: e.id, quantity: 1, properties: { _neu_install: 'auto' } });
          added.push({ title: e.title });
        });
        var w = window.__neuWarranty;   // {id,label,term,forVariant} or null — set by neu-warranty.js
        if (w && w.id && !have[w.id]) {
          var props = { _neu_warranty: w.term || 'plan' };
          if (w.forVariant) props._neu_warranty_for = String(w.forVariant);
          items.push({ id: w.id, quantity: 1, properties: props });
          added.push({ title: w.label });
        }
        if (!items.length) return [];
        return origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () { return added; });
      });
  }

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (!busy && method === 'POST' && isAddUrl(url)) {
      busy = true;
      return addConnectors()
        .then(function (added) { if (added && added.length) toast(added); })
        .catch(function () { /* never block the sale on a connector hiccup */ })
        .then(function () { busy = false; return origFetch(input, init); });
    }
    return origFetch(input, init);
  };

  /* ---- small on-brand "added" notification ---- */
  var CSS_ID = 'neu-conn-toast-css';
  function ensureCss() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent =
      '.neu-conn-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(16px);' +
      'z-index:2147483020;display:flex;gap:12px;align-items:flex-start;max-width:calc(100vw - 32px);width:360px;' +
      'background:#261849;color:#fff;border-left:4px solid #f7c407;border-radius:12px;padding:14px 16px;' +
      'box-shadow:0 16px 40px rgba(20,12,40,.4);font-family:Montserrat,system-ui,sans-serif;' +
      'opacity:0;transition:opacity .28s ease,transform .28s ease;}' +
      '.neu-conn-toast.is-on{opacity:1;transform:translateX(-50%) translateY(0);}' +
      '.neu-conn-toast__ic{flex:0 0 auto;width:24px;height:24px;border-radius:50%;background:#f7c407;color:#261849;' +
      'display:grid;place-items:center;font-weight:900;font-size:14px;line-height:1;margin-top:1px;}' +
      '.neu-conn-toast__body{flex:1 1 auto;min-width:0;}' +
      '.neu-conn-toast__t{display:block;font-size:.82rem;font-weight:800;letter-spacing:.02em;text-transform:uppercase;margin:0 0 3px;}' +
      '.neu-conn-toast__d{display:block;font-size:.8rem;line-height:1.35;color:#e7e0f2;}' +
      '.neu-conn-toast__x{flex:0 0 auto;background:none;border:none;color:#b9aed4;cursor:pointer;font-size:18px;line-height:1;padding:0 2px;}' +
      '.neu-conn-toast__x:hover{color:#fff;}' +
      '@media (max-width:600px){.neu-conn-toast{bottom:16px;}}';
    document.head.appendChild(s);
  }

  function cleanName(t) { return String(t || '').split(':')[0].trim(); }

  function toast(items) {
    ensureCss();
    var names = items.map(function (e) { return cleanName(e.title); }).filter(Boolean);
    var desc;
    if (names.length <= 2) { desc = names.join(' &amp; '); }
    else { desc = names.slice(0, 2).join(', ') + ' +' + (names.length - 2) + ' more'; }

    var el = document.createElement('div');
    el.className = 'neu-conn-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="neu-conn-toast__ic" aria-hidden="true">&#10003;</span>' +
      '<div class="neu-conn-toast__body">' +
        '<span class="neu-conn-toast__t">Added to your order</span>' +
        '<span class="neu-conn-toast__d">' + desc + '</span>' +
      '</div>' +
      '<button type="button" class="neu-conn-toast__x" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });

    var timer;
    function dismiss() {
      clearTimeout(timer);
      el.classList.remove('is-on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
    }
    el.querySelector('.neu-conn-toast__x').addEventListener('click', dismiss);
    timer = setTimeout(dismiss, 5000);
  }
})();
